import { NgModule } from '@angular/core';
import { IonicApp, IonicModule } from 'ionic-angular';
import { AngularFireModule } from 'angularfire2';
import { Storage } from '@ionic/storage';
import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { TabsPage } from '../pages/tabs/tabs';
import { ListMenus } from '../pages/menus/menus';
import { CreationPage } from '../pages/creation/creation';
import { PreferencesPage } from '../pages/preferences/preferences';
import { AuthentificationService} from '../providers/authentification-service';
import { PreferencesService} from '../providers/preferences-service';
import { MenusService } from '../providers/menus-service';

// Must export the config
const firebaseConfig = {
  apiKey: 'AIzaSyDh0CbCa22x94Ey0cbH2gdY4nYncueMCBI',
  authDomain: 'frimenus.firebaseapp.com',
  databaseURL: 'https://frimenus.firebaseio.com',
  storageBucket: 'frimenus.appspot.com',
  messagingSenderId: "845370696382"
}

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    TabsPage,
    CreationPage,
	  ListMenus,
    PreferencesPage
  ],
  imports: [
    IonicModule.forRoot(MyApp),
    AngularFireModule.initializeApp(firebaseConfig),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    TabsPage,
    CreationPage,
	  ListMenus,
    PreferencesPage
  ],
  providers: [
    Storage,
    AuthentificationService,
    MenusService,
    PreferencesService
    ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts